'use client'

import cartIcon from '@public/images/cart.svg'
import Image from 'next/image'

import { Container } from '@src/components/Container/Container'
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { useCart } from '@src/hooks/useCart'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'
import { getCartQuantity } from '@src/utils/cart.util'
import { cn } from '@src/utils/tailwind'

export const TopNavMobileBar = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { t } = useLocale('common')
  const cart = useCart()
  const quantity = getCartQuantity(cart.cart)
  const {
    isMobileSubExpanded,
    logo,
    signUpCta,
    isExpanded,
    setExpanded,
    setExpandedMenu,
    setMobileSubExpanded,
  } = useTopNav()

  const renderHamburger = () => {
    return (
      <button
        data-testid="topNavMobileMenu"
        onClick={() => {
          if (!isExpanded || !isMobileSubExpanded) {
            setExpandedMenu(null)
            setMobileSubExpanded(false)
          }
          setExpanded(!isExpanded)
        }}
        className="flex size-6 appearance-none flex-col items-center justify-center
        *:h-0.5 *:w-6 *:rounded-sm *:bg-white *:transition-all"
      >
        <div
          className={cn('-translate-y-1', {
            'rotate-45 translate-y-0.5': isExpanded,
          })}
        ></div>
        <div
          className={cn({
            'opacity-0': isExpanded,
          })}
        ></div>
        <div
          className={cn('translate-y-1', {
            '-rotate-45 -translate-y-0.5': isExpanded,
          })}
        ></div>
      </button>
    )
  }

  return (
    <Container className="h-full *:h-full">
      <div className="flex h-full flex-row items-center justify-between">
        <div className="flex gap-6">
          <div className="flex items-center">{renderHamburger()}</div>
          {logo?.src && (
            <LocalizedLink
              onClick={() => {
                trackSelectNavCta({ 'cta url': logo?.href })
              }}
              href={logo?.href ?? ''}
            >
              <Image
                src={logo.src}
                width={logo?.mobileWidth}
                height={logo?.mobileHeight}
                alt={logo?.altText ?? ''}
              />
            </LocalizedLink>
          )}
        </div>
        <div className="flex gap-6">
          <LocalizedLink data-testid="cartBtn" href="/cart" className="relative mt-0.5">
            <Image src={cartIcon} width={24} height={24} alt={t('view-cart')} />
            {quantity ? (
              <div
                className={cn(
                  'absolute top-0 left-full -mt-3 ml-[-18px] flex min-h-[24px] min-w-[24px] items-center justify-center rounded-full border-2 border-bodi-black-text bg-bodi-green-bright-500 text-body-xs font-semibold text-bodi-black',
                  { 'px-1.5': quantity > 99 }
                )}
              >
                {quantity > 999 ? '999' : quantity}
              </div>
            ) : null}
          </LocalizedLink>
          {signUpCta && (
            <LocalizedLink
              data-testid="signUpBtn"
              onClick={() => {
                trackSelectNavCta({ 'cta url': signUpCta?.href })
              }}
              href={signUpCta?.href ?? ''}
              rel={signUpCta?.newTab ? 'noopener noreferrer' : ''}
              target={signUpCta?.newTab ? '_blank' : '_self'}
              className="block"
            >
              <p className="text-body-md">{signUpCta?.title}</p>
            </LocalizedLink>
          )}
        </div>
      </div>
    </Container>
  )
}
